import React, { useContext, useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';


import 'bootstrap-daterangepicker/daterangepicker.css';
import { ClassifierContext } from '../../context/classifier/ClassifierContext';
import Message from '../../components/ui/Message';
import { ClassifierValue } from '../../models/interfaces';



export const ClassifierValuesPage = () => {

    const navigate = useNavigate();
    const location = useLocation();

    const { classifier } = location.state;


    const {
        values,
        loadValues,
        deleteValue,
        setDefaultValue,
        isLoading
    } = useContext(ClassifierContext);


    const [buscar, setBuscar] = useState('');

    const [errorMessage, setErrorMessage] = useState('');

    const [successMessage, setSuccessMessage] = useState('');



    useEffect(() => {

        loadValues(classifier.classifierId);

    }, []);



    const filteredData =
        values.filter(v =>

            v.valueCode
                .toLowerCase()
                .includes(buscar.toLowerCase())

        ).sort((a, b) =>
            a.valueName.localeCompare(b.valueName)
        );

    const removeError = () => { setErrorMessage(''); }
    const removeSuccessMessage = () => {
        setSuccessMessage('');
        navigate(-1);
    }



    const handleNew = () => {

        navigate('/classifier/value', {

            state: {
                classifier
            }

        });

    }



    const handleEdit = (value) => {

        navigate('/classifier/value', {

            state: {
                classifier,
                value
            }

        });

    }

    const handleFis = (classifierValue: ClassifierValue) => {
        navigate('/classifier/value/fis', { state: { classifier, classifierValue } });
    };



    const handleDelete = async (valueCode) => {

        const resp =
            await deleteValue(

                classifier.classifierId,
                valueCode

            );


        if (resp !== "success")
            setErrorMessage(resp);

    }



    const handleDefault = async (valueCode) => {

        const resp =
            await setDefaultValue(

                classifier.classifierId,
                valueCode

            );

        if (resp !== "success") {
            setErrorMessage(resp);
        } else {
            setSuccessMessage("Valor definido por defecto correctamente")
        }
    }



    return (

        <div className="mt-5 container" style={styles.container}>


            <h4>

                Valores del clasificador:

                {" "}
                <b>

                    {classifier.name}

                </b>

            </h4>


            <hr />



            {/* Buscador */}

            <div className="row justify-content-end mt-4">


                <div className="col-md-3">

                    <input

                        className="form-control"

                        type="text"

                        placeholder="Buscar"

                        value={buscar}

                        onChange={e => setBuscar(e.target.value)}

                    />

                </div>


                <div className="col-md-1">

                    <button

                        className="btn btn-success"

                        onClick={handleNew}

                    >

                        Nuevo

                    </button>

                </div>


            </div>


            <br />


            {/* Tabla */}


            <table className="table table-hover table-striped">


                <thead>

                    <tr>

                        <th>Código</th>

                        <th>Nombre</th>

                        {/* <th>Default</th> */}

                        <th style={{ textAlign: 'center' }}>

                            Acciones

                        </th>

                    </tr>

                </thead>



                <tbody>


                    {

                        filteredData.length > 0

                            ?

                            filteredData.map(value => (

                                <tr key={value.valueCode}>


                                    <td>

                                        {value.valueCode}

                                    </td>


                                    <td>

                                        {value.valueName}

                                    </td>






                                    <td style={{ textAlign: 'center' }}>



                                        <div className="dropdown">


                                            <button

                                                className="btn btn-secondary dropdown-toggle"

                                                data-bs-toggle="dropdown"

                                            >

                                                <span className="bi bi-list"></span>

                                            </button>



                                            <ul className="dropdown-menu">


                                                <li>

                                                    <button

                                                        className="dropdown-item"

                                                        onClick={() => handleEdit(value)}

                                                    >

                                                        <i className="bi bi-pencil me-2"></i>

                                                        Editar

                                                    </button>

                                                </li>

                                                <li>

                                                    <button
                                                        className="dropdown-item"
                                                        onClick={() => handleFis(value)}
                                                    >

                                                        <i className="bi bi-bank me-2"></i>

                                                        Instituciones

                                                    </button>

                                                </li>


                                                <li>

                                                    <button

                                                        className="dropdown-item"

                                                        onClick={() => handleDefault(value.valueCode)}

                                                    >

                                                        <i className="bi bi-star me-2"></i>

                                                        Marcar Default

                                                    </button>

                                                </li>



                                                <li>

                                                    <hr className="dropdown-divider" />

                                                </li>


                                                <li>

                                                    <button

                                                        className="dropdown-item text-danger"

                                                        onClick={() => handleDelete(value.valueCode)}

                                                    >

                                                        <i className="bi bi-trash me-2"></i>

                                                        Eliminar

                                                    </button>

                                                </li>



                                            </ul>


                                        </div>


                                    </td>


                                </tr>

                            ))

                            :

                            <tr>

                                <td colSpan={4} className="text-center">

                                    {

                                        isLoading

                                            ?

                                            "Cargando..."

                                            :

                                            "No existen valores."

                                    }

                                </td>

                            </tr>

                    }


                </tbody>


            </table>



            <div className="text-center mt-4">

                <button

                    className="btn btn-outline-secondary"

                    onClick={() => navigate(-1)}

                >

                    Atrás

                </button>

            </div>


            {

                errorMessage.length > 0

                    ?

                    <Message
                        type='error'
                        message={errorMessage}
                        closeDialog={removeError}
                        handleOk={removeError}
                        backgroundColor='rgba(0,0,0,0.4)'
                    />

                    :

                    ''

            }

            {successMessage &&
                <Message
                    type="success"
                    title="Exitoso"
                    message={successMessage}
                    closeDialog={removeSuccessMessage}
                    handleOk={removeSuccessMessage}
                    backgroundColor="rgba(0,0,0,0.4)"
                />
            }
        </div>

    );

}



const styles = {

    container: {

        flex: 1,
        marginTop: 10,
        marginHorizontal: 20

    }

};